module.exports = __webpack_public_path__ + "img/Bear-Creek-west.5e42cdc1.png";